<template>
  <div class ="Dashboard" v-if="!mobile">
    <v-container class="pr-16 pl-16">
      <DynamicDash />
    </v-container>
  </div>
  <div class ="Dashboard" v-else>
    <v-container>
      <v-row justify="center" class="center">
        <v-col col=12 sm="6">
          <v-row>
            <v-col cols="12" class="pb-2 pt-2">
              <div class="primary--text text-uppercase text-h4 text-sm-h4  text-lg-h2 text-center">
                <span class="font-weight-medium font-italic font-bold">Rapid</span>
                <span> Quote</span>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class= "pb-2 pt-2">
              <div class="primary--text text-uppercase text-body-2 text-sm-body text-md-h6 text-center font-weight-light">
                it’s all about the data
              </div>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="mt-12">
            <v-col cols="12">
              <v-form>
                <v-card class="primary">
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" class="pb-sm-0 pt-sm-0 pb-md-2 pt-md-2 pb-lg-2 pb-lg-2">
                          <div class="headline secondary--text text-h5 text-center">Create A Proposal!</div>
                        </v-col>
                      </v-row>
                      <v-row>
                          <v-col cols="12" class=" mt-sm-12">
                            <v-btn color="secondary primary--text" class="mr-4" block large @click="create">
                            Create Proposal
                            <v-icon right dark>mdi-arrow-right-circle</v-icon>
                            </v-btn>
                          </v-col>
                          <v-spacer></v-spacer>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-form>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import DynamicDash from '@/components/dashcomps/DynamicDash';  

  export default {
    components: { DynamicDash },
    data: () => ({
    }),

    mounted(){
      this.getDashboardDataForWidgets();
    },
    
    computed: {
      
      mobile () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return true;
          case 'sm': return true;
          case 'md': return false;
          case 'lg': return false;
          case 'xl': return false;
        }
        return null
      },
        
      min_width () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 200;
          case 'sm': return 400;
          case 'md': return 800;
          case 'lg': return 800;
          case 'xl': return 1200;
        }
        return null
      },
    
    },

    methods: {

      ...mapActions(['getDashboardDataForWidgets']),
      
      create(){
        this.$router.push({
          name: 'clientmanagement'
        })
      }
        
    },
    
  };
</script>


<style scoped>

  .Dashboard {
    background-image: url("~@/assets/dash-background.jpg");
    background-color: #cccccc; /* Used if the image is unavailable */
    height: calc(100vh - 64px); /* You must set a specified height */
    background-position: center; /* Center the image */
    background-repeat: no-repeat; /* Do not repeat the image */
    background-size: cover; /* Resize the background image to cover the entire container */
  }
  
  .center-text {
    text-align: center;
  }
  
</style>